import { RedoButton } from "@redotech/redo-web/arbiter-components/buttons/redo-button";
import { Flex } from "@redotech/redo-web/flex";
import { Text } from "@redotech/redo-web/text";
import { memo, useState } from "react";

export const ViewAllOrdersButton = memo(function ViewAllOrdersButton({
  emailSent,
  showRetry,
  triggerSendEmail,
  sendEmailError,
}: {
  emailSent: boolean;
  showRetry: boolean;
  triggerSendEmail: () => void;
  sendEmailError: string | undefined;
}) {
  const [isRetryDisabled, setIsRetryDisabled] = useState(false);

  const handleRetryClick = () => {
    if (isRetryDisabled) return;

    setIsRetryDisabled(true);
    triggerSendEmail();

    setTimeout(() => {
      setIsRetryDisabled(false);
    }, 2000);
  };

  if (sendEmailError) {
    return (
      <Text color="var(--color-text-error)" fontSize="sm">
        {sendEmailError}
      </Text>
    );
  }

  if (emailSent) {
    return (
      <Flex align="center" dir="column" gap="sm">
        <Text fontSize="lg" fontWeight="medium">
          Link sent. Check your email!
        </Text>
        {showRetry && (
          <RedoButton
            disabled={isRetryDisabled}
            hierarchy="link_underline"
            onClick={handleRetryClick}
            text="Didn't receive an email? Click here"
          />
        )}
      </Flex>
    );
  }

  return (
    <RedoButton
      disabled={isRetryDisabled}
      hierarchy="link_underline"
      onClick={handleRetryClick}
      text="View all orders by signing in via email"
    />
  );
});
